import { AppConfig } from './app.config';
import { Inject, Injectable, NgModule } from '@angular/core';
/**
 * NotificationService will notify using Desktop Notifications
 * https://developer.mozilla.org/en-US/docs/Web/API/notification
 * Can change icons by setting iconPath in the AppConfig if needed
 */
var NotificationService = (function () {
    function NotificationService(config) {
        this.config = config;
        this.iconPath = config.iconPath;
    }
    /**
     * Displays an error message
     * @param body
     */
    NotificationService.prototype.displayErrorMessage = function (body) {
        this.displayMessage('Error', body, 'error');
    };
    /**
     * Displays a success message
     * @param body
     */
    NotificationService.prototype.displaySuccessMessage = function (body) {
        this.displayMessage('Success', body, 'success');
    };
    /**
     * Displays an Info message
     * @param body
     */
    NotificationService.prototype.displayInfoMessage = function (body) {
        this.displayMessage('Info', body, 'info');
    };
    /**
     * Display message for passed in type
     * @param title
     * @param body
     * @param type
     */
    NotificationService.prototype.displayMessage = function (title, body, type) {
        var myNotification;
        myNotification = new Notification(type, {
            body: body,
            icon: this.iconPath + '/' + type + '.png'
        });
    };
    return NotificationService;
}());
export { NotificationService };
NotificationService.decorators = [
    { type: Injectable },
    { type: Inject, args: ['config',] },
];
/** @nocollapse */
NotificationService.ctorParameters = function () { return [
    { type: AppConfig, },
]; };
var DotNotificationModule = (function () {
    function DotNotificationModule() {
    }
    return DotNotificationModule;
}());
export { DotNotificationModule };
DotNotificationModule.decorators = [
    { type: NgModule, args: [{
                providers: [AppConfig, NotificationService]
            },] },
];
/** @nocollapse */
DotNotificationModule.ctorParameters = function () { return []; };
//# sourceMappingURL=notification.service.js.map